var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "side-nav", attrs: { id: "side-nav" } },
    [
      _c("div", {
        directives: [
          { name: "gtag", rawName: "v-gtag:viewRules", arg: "viewRules" },
        ],
        staticClass: "rules",
        attrs: { "data-type": "button" },
        on: {
          click: function ($event) {
            _vm.visible = true
          },
        },
      }),
      _c("a", {
        directives: [
          {
            name: "gtag",
            rawName: "v-gtag:download",
            value: "download-PC floating",
            expression: "'download-PC floating'",
            arg: "download",
          },
        ],
        staticClass: "download download__nav",
        attrs: {
          href: _vm.downloadLink.pc,
          target: "_blank",
          "data-type": "button",
        },
      }),
      _c("div", { staticClass: "qrcode" }, [
        _c("img", {
          attrs: {
            src: _vm.qrcodeUrl,
            alt: _vm.$locale.sideNav.scanToDownload,
          },
        }),
        _c("div", { staticClass: "qrcode-text" }),
      ]),
      _c("div", { staticClass: "backtop", on: { click: _vm.backTop } }, [
        _vm._v("TOP"),
      ]),
      _c("DlgRule", {
        attrs: { visible: _vm.visible },
        on: {
          close: function ($event) {
            _vm.visible = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }